import LookupService from "../../../Services/LookupService";
import AgencyGroupModel from "../../model/AgencyGroupModel";
import AgencyMembershipModel from "../../model/AgencyMembershipModel";
import AgencyGroupSetupAPI from "../../../Admin/Services/AgencyGroupSetupAPI";


class AgencySetupService {
    agencyGroupSetupAPI: AgencyGroupSetupAPI = new AgencyGroupSetupAPI();

    public fetchAgencies = async () => {
        let agencyList = await LookupService.fetchAgencies();
        return agencyList ? agencyList.map(item => {
            return {
                label: item.lookupValue,
                value: item.id,
                isInactive: false
            }
        }) : [];
    }

    public saveAgencyGroup = async (agencyGroup: AgencyGroupModel, isUpdated: boolean) => {
        if (isUpdated) {
            return await this.agencyGroupSetupAPI.updateAgencyGroup(agencyGroup);
        }
        else {
            return await this.agencyGroupSetupAPI.saveAgencyGroup(agencyGroup);
        }
    }

    public deleteAgencyGroup = async (model: AgencyGroupModel) => {
        return await this.agencyGroupSetupAPI.deleteAgencyGroup(model);
    }

    public saveAgencyMembership = async (model: AgencyMembershipModel) => {
        return await this.agencyGroupSetupAPI.saveMembership(model);
    }
    public deleteAgencyMembership = async (model: AgencyMembershipModel) => {
        return await this.agencyGroupSetupAPI.deleteMembership(model);
    }
}

export default AgencySetupService;